import React, { useContext, useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import OrgDetails from "./tabs/OrgDetails";
import OrgContact from "./tabs/OrgContact";
import Additional from "./tabs/Additional";
import Settings from "./tabs/Settings";
import { orgDetailsApi } from "../../services/org.services";
import { UserContext } from "../../context/UserContext";
import { getCookie } from "../../helpers/localStorage";
import { Role } from "../../constants/defaultKeys";

const OrganizationDashboard = () => {
  const { userDetails } = useContext(UserContext);
  const [orgDetails, setOrgDetails] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const query = useParams();
  const navigate = useNavigate();

  const defaultRole = userDetails?.currRole || getCookie(Role);
  const isOrgAdminOrOwner =
    defaultRole === "Organization_Owner" || defaultRole === "Organization_Admin";

  const refreshPage = () => {
    setRefresh((prev) => !prev);
  };

  useEffect(() => {
    orgDetailsApi()
      .then((res) => {
        setOrgDetails(res?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [refresh, query?.tab]);

  // Block direct access to /organization-settings/settings for non-org-admin roles
  useEffect(() => {
    if (query?.tab === "settings" && !isOrgAdminOrOwner) {
      navigate("/organization-settings/org-details", { replace: true });
    }
  }, [query?.tab, isOrgAdminOrOwner, navigate]);

  const CustomSideMenu = null;
  return (
    <>
      {query?.tab === "org-details" ? (
        <OrgDetails details={orgDetails} sideContent={CustomSideMenu} />
      ) : query?.tab === "contact" ? (
        <OrgContact
          data={orgDetails}
          refreshPage={refreshPage}
          sideContent={CustomSideMenu}
        />
      ) : query?.tab === "additional-information" ? (
        <Additional
          data={orgDetails}
          refreshPage={refreshPage}
          sideContent={CustomSideMenu}
        />
      ) : (
        <Settings
          data={orgDetails}
          refreshPage={refreshPage}
          sideContent={CustomSideMenu}
        />
      )}
    </>
  );
};

export default OrganizationDashboard;
